import styled from "styled-components";

import MoviesImage from "../assets/images/misc/movies.jpeg";
import TikTokImage from "../assets/images/misc/tiktok.jpeg";
import YouTubeImage from "../assets/images/misc/youtube.jpeg";
import LearnImage from "../assets/images/misc/learn.jpeg";
import RedditImage from "../assets/images/misc/reddit.jpeg";
import TwitterImage from "../assets/images/misc/twitter.jpeg";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ContainedSVG = styled.svg`
  width: 400px;
`;

const gifSelectionMap: { [key: string]: string } = {
  "Watch movies": MoviesImage,
  "Watch TikTok": TikTokImage,
  "Watch YouTube": YouTubeImage,
  Learn: LearnImage,
  "Browse through Reddit": RedditImage,
  "Browse through Twitter": TwitterImage,
};

const FakeGigglClient = ({ contentType }: { contentType: string }) => (
  <Wrapper>
    <ContainedSVG
      xmlns="http://www.w3.org/2000/svg"
      width="603"
      height="368"
      viewBox="0 0 603 368"
    >
      <defs>
        <pattern
          id="pattern"
          preserveAspectRatio="xMidYMid slice"
          width="100%"
          height="100%"
          viewBox="0 0 1280 1024"
        >
          <image
            width="1280"
            height="1024"
            xlinkHref={gifSelectionMap[contentType] || MoviesImage}
          />
        </pattern>
        <linearGradient
          id="linear-gradient"
          y1="0.5"
          x2="1"
          y2="0.5"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stop-color="#fff" />
          <stop offset="1" stop-color="#fff" />
        </linearGradient>
        <clipPath id="clip-Web_1920_1">
          <rect width="603" height="368" />
        </clipPath>
      </defs>
      <g
        id="Web_1920_1"
        data-name="Web 1920 – 1"
        clip-path="url(#clip-Web_1920_1)"
      >
        <path
          d="M583 0H20C8.9543 0 0 8.9543 0 20V348C0 359.046 8.9543 368 20 368H583C594.046 368 603 359.046 603 348V20C603 8.9543 594.046 0 583 0Z"
          fill="#222326"
        />
        <path d="M97 0V368" stroke="#707070" />
        <rect
          width="371"
          height="248"
          transform="translate(97)"
          fill="url(#pattern)"
        ></rect>
        <path
          d="M468 0H583C588.304 0 593.391 2.10714 597.142 5.85786C600.893 9.60859 603 14.6957 603 20V348C603 353.304 600.893 358.391 597.142 362.142C593.391 365.893 588.304 368 583 368H468V0Z"
          fill="#2B2B2B"
        />
        <path
          d="M20 0H97V368H20C14.6957 368 9.60859 365.893 5.85786 362.142C2.10714 358.391 0 353.304 0 348V20C0 14.6957 2.10714 9.60859 5.85786 5.85786C9.60859 2.10714 14.6957 0 20 0Z"
          fill="#353538"
        />
        <path
          d="M59.1316 118H17.8684C15.7322 118 14 120.239 14 123C14 125.761 15.7322 128 17.8684 128H38.5H59.1316C61.2678 128 63 125.761 63 123C63 120.239 61.2678 118 59.1316 118Z"
          fill="#676767"
        />
        <path
          d="M72.9474 84H19.0526C16.2625 84 14 86.2389 14 89C14 91.7611 16.2625 94 19.0526 94H72.9474C75.7375 94 78 91.7611 78 89C78 86.2389 75.7375 84 72.9474 84Z"
          fill="#676767"
        />
        <path
          d="M77.5526 101H19.4474C16.4392 101 14 103.239 14 106C14 108.761 16.4392 111 19.4474 111H77.5526C80.5608 111 83 108.761 83 106C83 103.239 80.5608 101 77.5526 101Z"
          fill="#676767"
        />
        <path
          d="M80.3158 67H19.6842C16.5453 67 14 69.2389 14 72C14 74.7611 16.5453 77 19.6842 77H80.3158C83.4547 77 86 74.7611 86 72C86 69.2389 83.4547 67 80.3158 67Z"
          fill="#676767"
        />
        <path
          d="M54.5263 158H17.4737C15.5554 158 14 160.239 14 163C14 165.761 15.5554 168 17.4737 168H54.5263C56.4446 168 58 165.761 58 163C58 160.239 56.4446 158 54.5263 158Z"
          fill="#676767"
        />
        <path
          d="M22.5281 194.056C27.2379 194.056 31.0562 190.238 31.0562 185.528C31.0562 180.818 27.2379 177 22.5281 177C17.8183 177 14 180.818 14 185.528C14 190.238 17.8183 194.056 22.5281 194.056Z"
          fill="#F4A78A"
        />
        <path
          d="M79.5112 177H42.2978C40.3712 177 38.809 178.562 38.809 180.489C38.809 182.415 40.3712 183.978 42.2978 183.978H79.5112C81.4378 183.978 83 182.415 83 180.489C83 178.562 81.4378 177 79.5112 177Z"
          fill="#676767"
        />
        <path
          d="M71.7584 187.079H42.2978C40.3712 187.079 38.809 188.641 38.809 190.567C38.809 192.494 40.3712 194.056 42.2978 194.056H71.7584C73.685 194.056 75.2472 192.494 75.2472 190.567C75.2472 188.641 73.685 187.079 71.7584 187.079Z"
          fill="#676767"
        />
        <path
          d="M22.5281 220.056C27.2379 220.056 31.0562 216.238 31.0562 211.528C31.0562 206.818 27.2379 203 22.5281 203C17.8183 203 14 206.818 14 211.528C14 216.238 17.8183 220.056 22.5281 220.056Z"
          fill="#55E0B4"
        />
        <path
          d="M68.4737 203H41.5263C40.1312 203 39 204.567 39 206.5C39 208.433 40.1312 210 41.5263 210H68.4737C69.8688 210 71 208.433 71 206.5C71 204.567 69.8688 203 68.4737 203Z"
          fill="#676767"
        />
        <path
          d="M78.7872 213H43.2128C40.8864 213 39 214.567 39 216.5C39 218.433 40.8864 220 43.2128 220H78.7872C81.1136 220 83 218.433 83 216.5C83 214.567 81.1136 213 78.7872 213Z"
          fill="#676767"
        />
        <path
          d="M22.5281 376.056C27.2379 376.056 31.0562 372.238 31.0562 367.528C31.0562 362.818 27.2379 359 22.5281 359C17.8183 359 14 362.818 14 367.528C14 372.238 17.8183 376.056 22.5281 376.056Z"
          fill="#55E0B4"
        />
        <path
          d="M72.1579 359H41.8421C40.2726 359 39 360.567 39 362.5C39 364.433 40.2726 366 41.8421 366H72.1579C73.7274 366 75 364.433 75 362.5C75 360.567 73.7274 359 72.1579 359Z"
          fill="#676767"
        />
        <path
          d="M22.5281 246.056C27.2379 246.056 31.0562 242.238 31.0562 237.528C31.0562 232.818 27.2379 229 22.5281 229C17.8183 229 14 232.818 14 237.528C14 242.238 17.8183 246.056 22.5281 246.056Z"
          fill="#BED3FF"
        />
        <path
          d="M61.1053 229H40.8947C39.8484 229 39 230.567 39 232.5C39 234.433 39.8484 236 40.8947 236H61.1053C62.1516 236 63 234.433 63 232.5C63 230.567 62.1516 229 61.1053 229Z"
          fill="#676767"
        />
        <path
          d="M71.7584 239.079H42.2978C40.3712 239.079 38.809 240.641 38.809 242.567C38.809 244.494 40.3712 246.056 42.2978 246.056H71.7584C73.685 246.056 75.2472 244.494 75.2472 242.567C75.2472 240.641 73.685 239.079 71.7584 239.079Z"
          fill="#676767"
        />
        <path
          d="M22.5281 272.056C27.2379 272.056 31.0562 268.238 31.0562 263.528C31.0562 258.818 27.2379 255 22.5281 255C17.8183 255 14 258.818 14 263.528C14 268.238 17.8183 272.056 22.5281 272.056Z"
          fill="#BED3FF"
        />
        <path
          d="M79.5112 255H42.2978C40.3712 255 38.809 256.562 38.809 258.489C38.809 260.415 40.3712 261.978 42.2978 261.978H79.5112C81.4378 261.978 83 260.415 83 258.489C83 256.562 81.4378 255 79.5112 255Z"
          fill="#676767"
        />
        <path
          d="M71.7584 265.079H42.2978C40.3712 265.079 38.809 266.641 38.809 268.567C38.809 270.494 40.3712 272.056 42.2978 272.056H71.7584C73.685 272.056 75.2472 270.494 75.2472 268.567C75.2472 266.641 73.685 265.079 71.7584 265.079Z"
          fill="#676767"
        />
        <path
          d="M22.5281 298.056C27.2379 298.056 31.0562 294.238 31.0562 289.528C31.0562 284.818 27.2379 281 22.5281 281C17.8183 281 14 284.818 14 289.528C14 294.238 17.8183 298.056 22.5281 298.056Z"
          fill="#F8D170"
        />
        <path
          d="M75.8421 281H42.1579C40.414 281 39 282.567 39 284.5C39 286.433 40.414 288 42.1579 288H75.8421C77.586 288 79 286.433 79 284.5C79 282.567 77.586 281 75.8421 281Z"
          fill="#676767"
        />
        <path
          d="M67.9362 291H42.0638C40.3719 291 39 292.567 39 294.5C39 296.433 40.3719 298 42.0638 298H67.9362C69.6281 298 71 296.433 71 294.5C71 292.567 69.6281 291 67.9362 291Z"
          fill="#676767"
        />
        <path
          d="M22.5281 324.056C27.2379 324.056 31.0562 320.238 31.0562 315.528C31.0562 310.818 27.2379 307 22.5281 307C17.8183 307 14 310.818 14 315.528C14 320.238 17.8183 324.056 22.5281 324.056Z"
          fill="#9F8AF4"
        />
        <path
          d="M66.6316 307H41.3684C40.0605 307 39 308.567 39 310.5C39 312.433 40.0605 314 41.3684 314H66.6316C67.9395 314 69 312.433 69 310.5C69 308.567 67.9395 307 66.6316 307Z"
          fill="#676767"
        />
        <path
          d="M78.7872 317H43.2128C40.8864 317 39 318.567 39 320.5C39 322.433 40.8864 324 43.2128 324H78.7872C81.1136 324 83 322.433 83 320.5C83 318.567 81.1136 317 78.7872 317Z"
          fill="#676767"
        />
        <path
          d="M22.5281 350.056C27.2379 350.056 31.0562 346.238 31.0562 341.528C31.0562 336.818 27.2379 333 22.5281 333C17.8183 333 14 336.818 14 341.528C14 346.238 17.8183 350.056 22.5281 350.056Z"
          fill="#F48AD6"
        />
        <path
          d="M79.5112 333H42.2978C40.3712 333 38.809 334.562 38.809 336.489C38.809 338.415 40.3712 339.978 42.2978 339.978H79.5112C81.4378 339.978 83 338.415 83 336.489C83 334.562 81.4378 333 79.5112 333Z"
          fill="#676767"
        />
        <path
          d="M71.7584 343.079H42.2978C40.3712 343.079 38.809 344.641 38.809 346.567C38.809 348.494 40.3712 350.056 42.2978 350.056H71.7584C73.685 350.056 75.2472 348.494 75.2472 346.567C75.2472 344.641 73.685 343.079 71.7584 343.079Z"
          fill="#676767"
        />
        <path
          d="M199 339C215.569 339 229 325.569 229 309C229 292.431 215.569 279 199 279C182.431 279 169 292.431 169 309C169 325.569 182.431 339 199 339Z"
          fill="#F8D170"
        />
        <path
          d="M283 339C299.569 339 313 325.569 313 309C313 292.431 299.569 279 283 279C266.431 279 253 292.431 253 309C253 325.569 266.431 339 283 339Z"
          fill="#F4A78A"
        />
        <path
          d="M367 339C383.569 339 397 325.569 397 309C397 292.431 383.569 279 367 279C350.431 279 337 292.431 337 309C337 325.569 350.431 339 367 339Z"
          fill="#BED3FF"
        />
        <path
          d="M468 0H583C588.304 0 593.391 2.10714 597.142 5.85786C600.893 9.60859 603 14.6957 603 20V49H468V0Z"
          fill="#343434"
        />
        <path
          d="M524 18H490C486.134 18 483 21.134 483 25C483 28.866 486.134 32 490 32H524C527.866 32 531 28.866 531 25C531 21.134 527.866 18 524 18Z"
          fill="#676767"
        />
        <path
          d="M494 89C500.075 89 505 84.0751 505 78C505 71.9249 500.075 67 494 67C487.925 67 483 71.9249 483 78C483 84.0751 487.925 89 494 89Z"
          fill="#BED3FF"
        />
        <path
          d="M550.5 67H519.5C517.015 67 515 69.0147 515 71.5C515 73.9853 517.015 76 519.5 76H550.5C552.985 76 555 73.9853 555 71.5C555 69.0147 552.985 67 550.5 67Z"
          fill="#676767"
        />
        <path
          d="M578.5 80H519.5C517.015 80 515 82.0147 515 84.5C515 86.9853 517.015 89 519.5 89H578.5C580.985 89 583 86.9853 583 84.5C583 82.0147 580.985 80 578.5 80Z"
          fill="#676767"
        />
        <path
          d="M494 135C500.075 135 505 130.075 505 124C505 117.925 500.075 113 494 113C487.925 113 483 117.925 483 124C483 130.075 487.925 135 494 135Z"
          fill="#55E0B4"
        />
        <path
          d="M544.5 113H519.5C517.015 113 515 115.015 515 117.5C515 119.985 517.015 122 519.5 122H544.5C546.985 122 549 119.985 549 117.5C549 115.015 546.985 113 544.5 113Z"
          fill="#676767"
        />
        <path
          d="M539.5 126H519.5C517.015 126 515 128.015 515 130.5C515 132.985 517.015 135 519.5 135H539.5C541.985 135 544 132.985 544 130.5C544 128.015 541.985 126 539.5 126Z"
          fill="#676767"
        />
        <path
          d="M493 181C499.075 181 504 176.075 504 170C504 163.925 499.075 159 493 159C486.925 159 482 163.925 482 170C482 176.075 486.925 181 493 181Z"
          fill="#F4A78A"
        />
        <path
          d="M566.5 159H518.5C516.015 159 514 161.015 514 163.5C514 165.985 516.015 168 518.5 168H566.5C568.985 168 571 165.985 571 163.5C571 161.015 568.985 159 566.5 159Z"
          fill="#676767"
        />
        <path
          d="M556.5 172H518.5C516.015 172 514 174.015 514 176.5C514 178.985 516.015 181 518.5 181H556.5C558.985 181 561 178.985 561 176.5C561 174.015 558.985 172 556.5 172Z"
          fill="#676767"
        />
        <path
          d="M468 315H603V344C603 349.304 600.893 354.391 597.142 358.142C593.391 361.893 588.304 364 583 364H468V315Z"
          fill="#343434"
        />
        <g clip-path="url(#clip1_153_415)">
          <path
            d="M50.0975 23.3927C50.0975 24.2895 49.3531 24.9767 48.4552 24.9767C47.5393 24.9767 46.7938 24.2895 46.7938 23.3927C46.7882 22.4757 47.5337 21.7851 48.4496 21.7851C48.664 21.78 48.8772 21.8179 49.0768 21.8963C49.2764 21.9748 49.4583 22.0924 49.6118 22.2421C49.7653 22.3919 49.8874 22.5708 49.9708 22.7684C50.0542 22.966 50.0973 23.1782 50.0975 23.3927ZM49.7343 35.9876H47.1559V26.8007L49.7343 26.7917V35.9876ZM72.7156 35.9876H70.1372V21.9757L72.7156 21.96V35.9876ZM40.9745 26.8298C40.9745 26.8298 36.5239 26.8298 36.5239 31.4989C36.5239 31.4989 36.4118 35.9427 41.1023 35.9831L44.0596 35.9741C44.0596 35.9741 44.3387 37.3754 41.9666 37.3754L37.4354 37.3676V39.6321H41.9599C41.9599 39.6321 46.7803 39.9975 46.7803 35.9842C46.7803 35.9842 46.805 26.7917 46.805 26.8287L40.9745 26.8298ZM44.1134 33.6816H41.4655C40.6886 33.6816 40.1415 33.5123 39.7951 33.1637C39.2346 32.6032 39.1931 31.62 39.1909 31.5359V31.4989C39.1909 29.4811 40.5451 29.1448 41.3388 29.1335H44.1235L44.1134 33.6816ZM54.4371 26.8298C54.4371 26.8298 49.9854 26.8298 49.9854 31.4978C49.9854 31.4978 49.8733 35.982 54.5626 35.982H57.4964C57.4964 35.982 57.8069 37.3866 55.4348 37.3866L50.8979 37.3676V39.6321H55.4213C55.4213 39.6321 60.2418 39.9975 60.2418 35.9842C60.2418 35.9842 60.2665 26.7917 60.2665 26.8287L54.4371 26.8298ZM57.5379 33.6816H54.8922C54.1153 33.6816 53.5682 33.5123 53.2218 33.1637C52.6613 32.6032 52.6198 31.62 52.6176 31.5359V31.4989C52.6176 29.4811 53.9707 29.1448 54.7644 29.1335H57.5491L57.5379 33.6816ZM63.9581 26.8298C63.9581 26.8298 59.5075 26.8298 59.5075 31.4989C59.5075 31.4989 59.3954 35.9831 64.0859 35.9831H67.0252C67.0252 35.9831 67.3357 37.3878 64.9647 37.3878L59.9089 37.3676V39.6321H64.9423C64.9423 39.6321 69.7628 39.9975 69.7628 35.9842C69.7628 35.9842 69.7875 26.7917 69.7875 26.8287L63.9581 26.8298ZM67.06 33.6816H64.4143C63.6363 33.6816 63.0892 33.5123 62.7428 33.1637C62.1823 32.6032 62.1408 31.62 62.1386 31.5359V31.4989C62.1386 29.4811 63.4917 29.1448 64.2854 29.1335H67.0712L67.06 33.6816Z"
            fill="white"
          />
          <path
            d="M30.4502 33.3621C32.1317 30.5505 32.8929 27.0349 30.9703 24.6718C31.5219 22.6472 31.2629 20.7706 28.9009 23.1023L28.7977 23.053C27.6464 22.7167 26.6184 22.6113 25.6902 22.6864C24.5008 19.7538 23.6331 21.0833 23.2901 23.3747C21.6959 24.2178 20.4875 25.7379 19.4785 27.5786C18.6209 26.7827 17.6501 25.7592 17.0638 24.748C17.0638 24.748 17.2734 26.6258 18.77 28.9833C17.0201 32.7265 15.8396 37.3014 14 40.2744C15.0728 39.7969 17.7129 38.1187 18.6927 37.4718C18.047 38.5783 16.6434 40.7554 15.9058 41.8125C18.001 40.7554 19.4931 40.2744 21.5558 38.8361C20.4695 39.5917 19.8743 40.5614 19.0705 41.6242C22.8562 40.0872 25.2889 39.196 28.5735 35.8217C28.8538 35.5347 29.1273 35.223 29.3908 34.8934C29.7525 35.9793 30.0862 37.0742 30.3919 38.1781C30.3044 37.8586 30.504 37.2532 30.5275 36.9113C30.5566 36.4674 30.5679 36.0231 30.5611 35.5784C30.5499 34.8553 30.4972 34.1266 30.4546 33.4047L30.4502 33.3621Z"
            fill="#FF0099"
          />
          <path
            d="M25.2833 25.379C25.5749 25.379 25.8113 25.1426 25.8113 24.851C25.8113 24.5594 25.5749 24.323 25.2833 24.323C24.9917 24.323 24.7553 24.5594 24.7553 24.851C24.7553 25.1426 24.9917 25.379 25.2833 25.379Z"
            fill="#2C0034"
          />
          <path
            d="M29.5746 25.7745C29.8662 25.7745 30.1026 25.5381 30.1026 25.2465C30.1026 24.9549 29.8662 24.7185 29.5746 24.7185C29.283 24.7185 29.0466 24.9549 29.0466 25.2465C29.0466 25.5381 29.283 25.7745 29.5746 25.7745Z"
            fill="#2C0034"
          />
          <path
            d="M26.207 25.9733C26.4783 26.3454 26.8776 26.6041 27.328 26.6998C27.328 26.6998 28.2518 26.6998 28.7854 26.0395C28.7832 26.0451 26.2731 25.9072 26.207 25.9733Z"
            fill="#2C0034"
          />
        </g>
      </g>
    </ContainedSVG>
  </Wrapper>
);

export default FakeGigglClient;
